import { Award, MapPin, Network, CheckCircle2 } from "lucide-react";
import { REASONS } from "@/data";
import { Reveal } from "@/components/Reveal";

const ICONS = { Award, MapPin, Network, CheckCircle2 };

const STATS = [
  { value: "SEP", label: "Uprawnienia dozorowe i eksploatacyjne" },
  { value: "5", label: "Kluczowych obszarów usług" },
  { value: "100%", label: "Protokoły dla nadzoru i ubezpieczycieli" },
];

export const Trust = () => {
  return (
    <section id="dlaczego-my" className="bg-zinc-50 py-24 sm:py-32" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-magenta">
              Dlaczego NDNS Elektro
            </span>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="mt-4 font-heading font-bold text-navy text-3xl sm:text-4xl lg:text-5xl tracking-tight">
              Rzetelne rzemiosło połączone z nowoczesną technologią
            </h2>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-6 text-base sm:text-lg text-zinc-600 leading-relaxed">
              Projektujemy, montujemy i serwisujemy systemy zasilania oraz wykonujemy zaawansowane
              sieci słaboprądowe, które gwarantują bezpieczeństwo i komfort w domach, mieszkaniach
              oraz obiektach komercyjnych i przemysłowych.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-200 border border-zinc-200">
          {REASONS.map((r, i) => {
            const Icon = ICONS[r.icon];
            return (
              <Reveal key={r.title} delay={i * 90} className="bg-white">
                <article className="h-full p-8 hover:bg-navy group transition-colors duration-300" data-testid={`reason-${i}`}>
                  <div className="w-12 h-12 bg-magenta flex items-center justify-center text-white">
                    <Icon className="w-6 h-6" strokeWidth={2} />
                  </div>
                  <h3 className="mt-6 font-heading font-bold text-xl text-navy group-hover:text-white transition-colors">
                    {r.title}
                  </h3>
                  <p className="mt-3 text-zinc-600 group-hover:text-zinc-300 leading-relaxed transition-colors">
                    {r.desc}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-px grid grid-cols-1 sm:grid-cols-3 gap-px bg-zinc-200 border border-zinc-200 border-t-0">
          {STATS.map((s) => (
            <div key={s.label} className="bg-navy p-8" data-testid="trust-stat">
              <div className="font-heading font-black text-4xl sm:text-5xl text-magenta-light">{s.value}</div>
              <div className="mt-2 text-sm text-zinc-300">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
